import React,{ Component } from 'react';
import ArticleDetailsContainer from './container/ArticleDetailsContainer';

export default class ArticleDetails extends Component{
    componentDidMount() {
        window.scrollTo(0,0)
    }
    render(){

        return(
            <React.Fragment>
                <ArticleDetailsContainer {...this.props} />
            </React.Fragment>

        )
    }
}
